export const roleConstants = {
  GET_ALL_BY_ORGANIZATION_REQUEST: 'GET_ALL_BY_ORGANIZATION_REQUEST',
  GET_ALL_BY_ORGANIZATION_SUCCESS: 'GET_ALL_BY_ORGANIZATION_SUCCESS',
  GET_ALL_BY_ORGANIZATION_FAILURE: 'GET_ALL_BY_ORGANIZATION_FAILURE',

  UPDATE_ROLE_REQUEST: 'UPDATE_ROLE_REQUEST',
  UPDATE_ROLE_SUCCESS: 'UPDATE_ROLE_SUCCESS',
  UPDATE_ROLE_FAILURE: 'UPDATE_ROLE_FAILURE',

  UPDATE_ROLES_REQUEST: 'UPDATE_ROLES_REQUEST',
  UPDATE_ROLES_SUCCESS: 'UPDATE_ROLES_SUCCESS',
  UPDATE_ROLES_FAILURE: 'UPDATE_ROLES_FAILURE',

  CREATE_ROLE_REQUEST: 'CREATE_ROLE_REQUEST',
  CREATE_ROLE_SUCCESS: 'CREATE_ROLE_SUCCESS',
  CREATE_ROLE_FAILURE: 'CREATE_ROLE_FAILURE',

  DELETE_ROLE_REQUEST: 'DELETE_ROLE_REQUEST',
  DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',
  DELETE_ROLE_FAILURE: 'DELETE_ROLE_FAILURE',
};
